export const COMPONENT_NAME = "admin-layout";
